export default "__VITE_ASSET__4b781978__"